module.exports = __webpack_public_path__ + "static/media/slc-logo-donatieform.fb382acd.svg";